import { useExerciseIdsSelect } from '@entities/exercise-video/model.ts';
import type { Identifier, XYCoord } from 'dnd-core';
import update from 'immutability-helper';
import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useFormContext } from 'react-hook-form';

interface DragItem {
  index: number;
  type: string;
}

const style = {
  cursor: 'move',
  width: 276,
  /* height: 197, */
};

const ItemTypes = {
  CARD: 'card',
};

type Props = {
  index: number;
  children: React.ReactNode;
  saveFormData?: () => void;
};

export const DnDCard: React.FC<Props> = ({ index, children, saveFormData }) => {
  const { setValue, getValues } = useFormContext();

  const { selectedIds: exercises, doResetSelectedIds: resetSelectedExerciseIds } =
    useExerciseIdsSelect();
  // const allExercises = exercises;

  const ref = React.useRef<HTMLDivElement>(null);

  const moveCard = React.useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const setExercises = (exercises: number[]) => {
        // Изменить список видео в редакторе программы
        // setValue('exercises', exercises, { shouldDirty: true });
        saveFormData?.();
        resetSelectedExerciseIds(exercises);

        // корректируем периодичность
        const excludedVideos = getValues('excluded_videos_period');
        const allVideos = [...exercises];
        const newExcluded = [];
        for (const day of excludedVideos) {
          const excludedVideos = allVideos.filter((video) => day.includes(video));
          newExcluded.push(excludedVideos);
        }
        setValue('excluded_videos_period', newExcluded);
      };

      const newExercises = update(exercises, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, exercises[dragIndex]],
        ],
      });

      setExercises(newExercises);
    },
    [exercises, getValues]
  );

  const [{ handlerId }, drop] = useDrop<DragItem, void, { handlerId: Identifier | null }>({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item: DragItem, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientX = (clientOffset as XYCoord).x - hoverBoundingRect.left;
      if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { index };
    },
    collect: (monitor: any) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
      {children}
    </div>
  );
};
